"use client";

import React from "react";
import { Mail } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface CtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, CtaCopy> = {
  en: {
    eyebrow: "Stainless Steel & Alloys",
    heading: "Need Custom Alloy Wire Mesh Specifications?",
    lead: "Share your target aperture, weave style, and alloy grade for technical engineering review and competitive B2B volume supply.",
    secondaryLabel: "Contact Technical Sales",
    note: "Conditional material test reports (MTR) and PMI available when specified in order."
  },
  zh: {
    eyebrow: "不锈钢与合金丝网",
    heading: "需要定制合金丝网规格与技术参数？",
    lead: "提供您的目标孔径、编织形式与合金牌号，我们的应用工程团队将进行技术核对并提供有竞争力的批量供应方案。",
    secondaryLabel: "联系技术团队",
    note: "可按订单要求提供材料试验报告（MTR）与 PMI 元素光谱复验。"
  },
  es: {
    eyebrow: "Acero inoxidable y aleaciones",
    heading: "¿Necesita especificaciones a medida en malla de aleación?",
    lead: "Comparta la abertura objetivo, el tipo de tejido y el grado de aleación para una revisión técnica y suministro B2B competitivo.",
    secondaryLabel: "Contactar con ventas técnicas",
    note: "Informes de ensayo de material (MTR) y PMI disponibles según especificación del pedido."
  },
  de: {
    eyebrow: "Edelstahl & Legierungen",
    heading: "Benötigen Sie maßgeschneiderte Legierungs-Drahtgewebe?",
    lead: "Teilen Sie uns Maschenweite, Webart und Werkstoffgüte mit – für eine fundierte technische Prüfung und wettbewerbsfähige B2B-Lieferung.",
    secondaryLabel: "Technischen Vertrieb kontaktieren",
    note: "Materialprüfzeugnisse (MTR) und PMI auf Bestellanforderung erhältlich."
  },
  fr: {
    eyebrow: "Acier inoxydable et alliages",
    heading: "Besoin de toiles métalliques en alliage sur mesure ?",
    lead: "Transmettez votre ouverture de maille, type de tissage et nuance d'alliage pour une étude technique et une offre B2B compétitive.",
    secondaryLabel: "Contacter le service technique",
    note: "Rapports d'essais matières (MTR) et contrôle PMI disponibles sur spécification de commande."
  },
  pt: {
    eyebrow: "Aço inoxidável e ligas",
    heading: "Precisa de especificações sob medida em tela metálica?",
    lead: "Envie a abertura pretendida, o tipo de tecelagem e a liga metálica para avaliação técnica e fornecimento B2B competitivo.",
    secondaryLabel: "Contatar equipe técnica",
    note: "Relatórios de teste de material (MTR) e PMI disponíveis quando especificado no pedido."
  }
};
export default function QuoteCTA() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="quotecta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/ContactPage",
    icon: Mail
  }} note={copy.note} />;
}